import { applyMiddleware, compose, createStore } from 'redux'
import reduxCatch from 'redux-catch'
import { thunk } from 'redux-thunk'

import { logError } from '@albacross/frontend-utils'

const logReducerError = (error, _getState) => logError('REDUX error', error, _getState())

const configureStore = (rootReducer, initialState = {}, extraMiddleware: any[] = []) => {
  // Compose final middleware and use devtools in debug environment
  let middleware = [reduxCatch(logReducerError), thunk]

  if (typeof window !== 'undefined' && window.analytics) {
    middleware = [...middleware, ...extraMiddleware]
  }

  const composeEnhancers = (typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose

  return createStore(rootReducer(), initialState, composeEnhancers(applyMiddleware(...middleware)))
}

export default configureStore
